<template>
  <div>
    <div class="sino-card" v-loading.fullscreen.lock="loading"  v-show="!signatureShow" >
      <top-part :rightPart="true"></top-part>
      
      <!-- 活动内容。 -->
      <div class='activity-detail ctn_top'>
        <div class=' my-submit-top'>
            <div class='my-online-title'>活动名称：{{name}}</div>
            <div class='my-online-title'>活动介绍</div>

            <div class='activity-content activity-item'>
              <div class="content">
                  <span 
                    v-html="content"
                    ref="fold"
                    :style="{maxHeight:this.foldHeight?this.foldHeight+'px':'',overflowY:this.foldHeight?'scroll':''}"
                    class="detail"
                  ></span>
                  <span
                    class="sino-fold-btn"
                    @click="toggleFlod"
                    v-if="foldBtn"
                  >
                    {{fold?'收起':"展开"}}
                    <span
                      :class="['iconfont', fold?'iconfenhui-gonghuihuodongbuxubaomingzhuanhuan-6':'iconfenhui-gonghuihuodongbuxubaomingzhuanhuan-7']"
                    ></span>
                  </span>
              </div>
            </div>
          </div>
        </div>
          <!-- 活动内容。 -->
        <!-- 提交方式 -->
        <div class='my-activity-type-two'>
          <div>
            <img src="@/images/submit.png" />
            <span class='my-text-gray'>提交方式</span>
            <span>{{responseTypeName}}</span>
          </div>
        </div>
        <!-- 提交方式 -->
        <!-- 图片上传。备注 -->
        <div class='my-remark-photo'>
          <div>
            <div class='l2-title'></div>
            <el-input  type="textarea" placeholder="写备注或说明，如没有可不填" v-model="responseNote" maxlength="200"></el-input>
          </div>
          <div v-if='receiveResponse'>
            <div class='l2-title'>{{responseTypeObj[responseType]}}<span>{{textTip[responseType]}}</span></div>
            <van-uploader 
            :max-size="maxSize *1024 * 1024"
            @oversize="onOversize" 
            :accept="uploadType[responseType]" 
            :disabled="fileMessage=='上传中'" 
            v-model="fileList" max-count='3' 
            :after-read="afterImgRead"  />
          </div>
        </div>  
        <!-- 签名展示 开始 -->
        <div class="my_flex_sign" v-if="isSignature==1">
          <div class="sign_title">签名</div>
          <div v-if="signatureImg" class="resign">
            <img class="sign-img" :src="signatureImg" />
            <span @click="showPopup" class="resign-txt" >重新签名</span>
          </div>
          <div v-else class="signature_edit" @click="showPopup">
            <div>
              <img src="@/images/edit.png" alt />
              <span class="no_singature">签名</span>
            </div>
          </div>
        </div>
        <!-- 签名展示 结束 -->

        <!-- 图片上传。备注 -->
        <div class="my-submit-footer">
            <button :disabled="fileMessage=='上传中'"  @click='save'>保存为草稿</button>
            <button :disabled="fileMessage=='上传中'||submitLoading" v-loading="submitLoading"  @click='submit'>提交</button>
        </div>

    </div>

    <!-- 签名弹出框 -->
    <div v-show="signatureShow" class="sign" style="position:fixed;top:0;z-index:9999;bottom:0">
      <signature @closePop="closePop" @saveImg="complete"></signature>
    </div>
    <!-- 签名弹出框结束 -->


  </div>
  
</template>

<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import topPart from "../../components/topPart";
import signature from "../../components/signature.vue";
export default {
  components:{
    topPart,
    signature
  },
  data() {
    return {
     loading:false,
     responseNote:'',//备注
     foldHeight:'110',//内容最大高度
     content:'',
     foldBtn: true,//是否收起展开
     fold:false,//收起或展开
     fileList: [],//图片list
     responseTypeObj:{
       'photo':'图片上传',
        'walk':'走步',
        'video':'视频上传',
        'word':'文档上传',
     },
     uploadType:{
        'photo':'image/*',
        'video':'video/*',
        'word':'*.xls,.txt,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
     },
     textTip:{
      'photo':'（最多上传3张，大小不超过5M）',
      'video':'（最多上传3个，大小不能超过50M）',
      'word':'（最多上传3个，大小不能超过5M）',
     },
      messageTip:{
       'photo':'图片',
        'video':'视频',
        'word':'文档',
     },
     responseType:'',//提交方式
     responseTypeName:'',//提交方式
     name:'',//标题
     isSubmit:false,//是否已经提交
     receiveResponse:'',//是否反馈
     maxSize:5,//
     fileMessage:'',
     submitId:'',//提交id
     submitLoading:false,
     signatureImg: "", //签名图片
     answeredId:'',
     signatureShow:false,
     isSignature:'',//是否需要签名
    };
  },
  mounted(){
    this.querySubmit();
    this.queryDetailFn();
  },
  methods:{
    // 存为草稿的数据
    // temporaryData(){
    //   const {id} =this.$route.query;
    //   let submitObj=JSON.parse(localStorage.getItem('submitObj'))
    //   if(submitObj&&submitObj[id]){
    //     let data = submitObj&&submitObj[id];
    //     this.responseNote=data.responseNote;
    //     this.fileList=data.files;
    //   } else {
    //     this.querySubmit();
    //   }
    // },
    showPopup(){
      this.signatureShow = true;
    },
    closePop() {
      this.signatureShow = false;
    },
    complete(data) {
      if (!data) return this.$message.error("保存签名失败");
      this.closePop();
      this.signatureImg=data;
    },
    onOversize(){
      toast(this, `文件大小不能超过${this.maxSize}M`, "error");
    },
    // 查询详情
    queryDetailFn(){
      const {id} =this.$route.query;
      this.centralControl.axios.centralControl(
        "wxOLActivityDetails",
        res => {
          this.loading = false;
          const {data={},code}=res;
          if (code == 200) {
            let {content,name,responseType,receiveResponse,isSignature,signatureUrl}=data;
            this.content=content
              .replace(new RegExp("&lt;", "g"), "<")
            .replace(new RegExp("&gt;", "g"), ">")
            .replace(new RegExp("&quot;", "g"), "");
            this.name=name;
            this.responseType=responseType;
            this.maxSize=responseType=='video'?50:5;
            this.responseTypeName=this.responseTypeObj[responseType];
            this.receiveResponse=receiveResponse;
            this.isSignature=isSignature;
            this.signatureImg=signatureUrl;
            // 处理展开与收起的逻辑
            this.$nextTick(()=>{
              let actualheight = this.$refs.fold.offsetHeight;
              let scrollHeight = this.$refs.fold.scrollHeight;
              this.contentScollHeight = scrollHeight;
              if (scrollHeight <= actualheight) {
                this.foldBtn = false;
              }
            })
          } else {

          }
        },
        {id}
      );
    },
    // 查询提交的数据
    querySubmit(){
      const {id} =this.$route.query;
      this.centralControl.axios.centralControl(
        "getSubmitFilesOfActivity",
        res => {
          this.loading = false;
          const {data={},code}=res;
          if (code == 200) {
            const {submitFiles,responseNote,id}=data;
            this.responseNote=responseNote;
            this.fileList=submitFiles;
            this.isSubmit= id?true:false;
            this.submitId=id;
            console.log(id,this.isSubmit,'999')
            if(!id){
              let submitObj=JSON.parse(localStorage.getItem('submitObj'))
              const queryId =this.$route.query.id;
              if(submitObj&&submitObj[queryId]){
                let data = submitObj&&submitObj[queryId];
                this.responseNote=data.responseNote;
                this.fileList=data.files;
              } 
            }
          } else {

          }
        },
        {activityId:id}
      );
    },
    // 图片上传成功回调
    afterImgRead(file){
      file.status = 'uploading';
      file.message = '上传中...';
      this.fileMessage = '上传中';
      var obj = {"file":file.file};
      this.centralControl.axios.centralControl(
        "uploadFile",
        res => {
          const {data={},code,message}=res;
          if (code == "200") {
            const {fileKey,temporaryUrl} = data;
            this.fileList[this.fileList.length-1].fileKey=fileKey;
            this.fileList[this.fileList.length-1].temporaryUrl=temporaryUrl;
            file.status = 'success';
            file.message = '上传成功';
            this.fileMessage = '上传成功';
          } else {
            file.status = 'failed';
            file.message = '上传失败'||message;
            this.fileMessage = '上传失败';
          }
        },
        obj
      );
    },
    // 保存为草稿
    save(){     
      const {id} =this.$route.query;
      // if (this.isSubmit)return toast(this, "已经提交过了哦", "error");
      let text = `${this.messageTip[this.responseType]}`;
      if ((!this.fileList||!this.fileList.length)&&this.receiveResponse) return toast(this, `请上传${text}`, "error");
      if(this.receiveResponse==0&&!this.responseNote)return;
      let arr=[];
      // 处理图片数组
      this.fileList&&this.fileList.forEach(item=>{
        arr.push({
          file_key:item.fileKey||item.file_key,
          url:item.temporaryUrl||item.url
        })
      })
      let params={
        activityId:id,
        files: arr
      }
      if(this.responseNote)params.responseNote=this.responseNote;
      let submitObj={
        [id]:params
      }
      localStorage.setItem('submitObj',JSON.stringify(submitObj));
      toast(this, "已保存", "success");
    },
    // 提交
    submit(){
      const {id} =this.$route.query;
      let arr=[];
      this.fileList&&this.fileList.forEach(item=>{
        arr.push({file_key:item.fileKey})
      })
      let params={
        activityId:id,
        files: JSON.stringify(arr)
      }
      let index = this.signatureImg.indexOf('data:image/png;base64,');
      if(this.signatureImg&&index>=0){
        params.signature=this.signatureImg;
      } 
      let text = `${this.messageTip[this.responseType]}`;
      if ((!this.fileList||!this.fileList.length)&&this.receiveResponse) return toast(this, `请上传${text}`, "error");
      if(this.isSignature==1&&!this.signatureImg) return toast(this, `请先签名`, "error");

      this.submitLoading=true;
      if(this.responseNote)params.responseNote=this.responseNote;
      let api = "submitFilesForActivity";
      if(this.isSubmit) {
        api = "updateSubmitedFilesForActivity";
        params.id=this.submitId;
      }
      this.centralControl.axios.centralControl(
        api,
        res => {
          const {data={},code,message}=res;
          this.submitLoading=false;
          if (code == 200) {
            toast(this, message, "success");

            let submitObj=JSON.parse(localStorage.getItem('submitObj'))
             const {id} =this.$route.query;
            if(submitObj&&submitObj[id])submitObj[id]=null;
            localStorage.setItem('submitObj',JSON.stringify(submitObj));
            history.go(-1);
          } else {
            toast(this, message, "error");
          }
        },
        params
      );
    },
    toggleFlod() {
      this.foldHeight="";
      this.fold = !this.fold;
      if (!this.fold) {
        this.foldHeight = "160";
      }
    },
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/theme.styl';
@import '../../assets/stylus/detail.styl';
  .my-submit-top {
    background: #FFF;
    padding: 15px;
    .my-online-title {
      font-size:18px;
      font-family:PingFang SC;
      font-weight:bold;
      color:$text-black;
      margin-top: 15px;
    }
    .my-online-title:nth-child(2){
      // text-indent:4px;
      font-size: 14px;
    }
  }
  
  .my-activity-type-two{
    background: #FFF;
    margin-top: 10px;
    div {
      line-height: 50px;
      margin-left:15px;
      img {
        width: 18px;
      }
    }
    >div:nth-child(1){ 
      border-bottom: 1px solid $border-gray;
    }
    .my-text-gray {
      // color:#888;
      margin: 0 20px 0 8px;
      font-family:PingFang SC;
    }
  }
  
  .my-remark-photo {
    background: #FFF;
    margin-top: 10px;
    >div {
      padding: 15px;
    }
    >div:nth-child(1){ 
      border-bottom: 1px solid $border-gray;
    }
    .l2-title {
      margin-bottom: 15px;
      span {
        color: $text-gray2;
        margin-left: 10px;
      }
    }
    .el-textarea__inner:focus{
      border:none;
    }
    .el-textarea__inner{
      border: none;
      height: 140px;
      background: rgba(244,245,249,1);
      // color: #B2B2B2;
      border-radius:10px;
    }
  }
  .my-submit-footer {
    z-index:100;
    display: flex;
    justify-content:space-around;
    background:#EFEFF4;
    padding:30px 0;
    >button {
      width:160px;
      height: 46px;
      border-radius: 8px;
      text-align:center;
      line-height:46px;
    }
    >button:nth-child(1){
      border: 1px solid $main-bgColor;
      color: $main-bgColor;
      background: #FFF;
    }
    >button:nth-child(2){
      background: $main-bgColor;
      color: #FFF;

    }
  }

   
  .my_flex_sign {
    display: flex;
    align-items: center;
    background: #FFF;
    padding: 16px;
    justify-content: space-between;

    .sign_title {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(53, 53, 53, 1);
    }
    .resign-txt {
      font-style: normal;
      margin: auto 0;
    }

    .resign {
      flex: 1;
      text-align: center;
      display: flex;
    }

    .sign-img {
      width: 60px;
      height: 60px;
      margin: auto;
      transform: rotate(90deg);
    }
    .signature_edit {
      width: 252px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid rgba(41, 190, 188, 1);

      .no_singature {
        display: inline-block;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(41, 190, 188, 1);
        line-height: 22px;
      }

      img {
        width: 16px;
        margin-right: 4px;
      }
    }

  }
  
</style>